import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const zkSyncSepolia: VToken[] = [
  {
    chainId: 300,
    address: "0x9c2379ed8ab06B44328487f61873C7c44BD6E87D",
    decimals: 8,
    symbol: "vWBTC_Core",
    underlyingToken: tokens[300][3]!,
  },
  {
    chainId: 300,
    address: "0x31eb7305f9fE281027028D0ba0d7f57ddA836d49",
    decimals: 8,
    symbol: "vWETH_Core",
    underlyingToken: tokens[300][2]!,
  },
  {
    chainId: 300,
    address: "0x58b0b248BB11DCAA9336bBf8a81914201fD49461",
    decimals: 8,
    symbol: "vUSDC.e_Core",
    underlyingToken: tokens[300][5]!,
  },
  {
    chainId: 300,
    address: "0x7Bfd185eF8380a72027bF65bFEEAb0242b147778",
    decimals: 8,
    symbol: "vUSDT_Core",
    underlyingToken: tokens[300][4]!,
  },
  {
    chainId: 300,
    address: "0x92f4BD794303c0BD0791B350Be5531DB38414f47",
    decimals: 8,
    symbol: "vZK_Core",
    underlyingToken: tokens[300][7]!,
  },
  {
    chainId: 300,
    address: "0xA266EfCC7D1a8F1AAd093446E3C0115467ea8b9C",
    decimals: 8,
    symbol: "vUSDC_Core",
    underlyingToken: tokens[300][6]!,
  },
  {
    chainId: 300,
    address: "0x63abcB1f579dB71b4b8A1E182adbA2F131b75681",
    decimals: 8,
    symbol: "vwUSDM_Core",
    underlyingToken: tokens[300][8]!,
  },
  {
    chainId: 300,
    address: "0x853ed4e6ab3a6747d71Bb79eDbc0A64FF87D31BF",
    decimals: 8,
    symbol: "vwstETH_Core",
    underlyingToken: tokens[300][9]!,
  },
  {
    chainId: 300,
    address: "0xac01abfbe100b56Fc414C346B175599E5f582912",
    decimals: 8,
    symbol: "vzkETH_Core",
    underlyingToken: tokens[300][10]!,
  },
];
